var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import styled from '@emotion/styled';
import { FormControl, FormControlLabel, Radio as MuiRadio, RadioGroup as MuiRadioGroup } from '@mui/material';
import Text from '../Text';
import { useCallback, useState } from 'react';
import colors from '../../themes/colors';
// eslint-disable-next-line
import tinycolor from 'tinycolor2';
var StyledRadioGroup = styled(MuiRadioGroup)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
    var alignment = _a.alignment;
    if (alignment === 'vertical')
        return '';
    return "\n      flex-direction: row;\n      gap: 16px;\n    ";
});
var getStyles = function (props) {
    var _a;
    var variant = props.variant, value = props.value;
    var styles = {
        margin: 'unset'
    };
    if (variant === 'boxed')
        Object.assign(styles, (_a = {
                maxWidth: '284px',
                width: '100%',
                height: 36,
                border: "1px solid ".concat(colors.neutral30),
                borderRadius: '4px',
                flex: 1,
                flexWrap: 'nowrap',
                backgroundColor: 'transparent',
                transition: 'background-color 0.05s ease-in-out',
                '&:not(:last-of-type)': {
                    marginBottom: '16px'
                },
                '.MuiRadio-root': {
                    padding: '7px'
                }
            },
            _a["&:has(input[value=".concat(value, "])")] = {
                border: "2px solid ".concat(colors.bigBangBlack)
            },
            _a['&:not(:has(.Mui-disabled)):hover'] = {
                backgroundColor: tinycolor(colors.neutral80).setAlpha(0.08).toString()
            },
            _a));
    return styles;
};
var RadioButtonGroup = function (props) {
    var options = props.options, value = props.value, onChange = props.onChange, _a = props.alignment, alignment = _a === void 0 ? 'horizontal' : _a, _b = props.variant, variant = _b === void 0 ? 'boxed' : _b;
    var _c = useState(value), state = _c[0], setState = _c[1];
    var onRadioButtonChange = useCallback(function (event) {
        setState(event.currentTarget.value);
        onChange === null || onChange === void 0 ? void 0 : onChange(event.currentTarget.value);
    }, [onChange]);
    var textVariant = variant === 'default' ? 'body2' : 'body2Semibold';
    return (_jsx(FormControl, __assign({ fullWidth: variant !== 'default' }, { children: _jsx(StyledRadioGroup, __assign({ variant: variant, alignment: alignment, defaultValue: state, value: state, onChange: onRadioButtonChange }, { children: options.map(function (option) { return (_jsx(FormControlLabel, { sx: getStyles(__assign(__assign({}, props), { value: state })), control: _jsx(MuiRadio, { disableRipple: true }), label: _jsx(Text, __assign({ variant: textVariant }, { children: option.label })), value: option.value, disabled: option.disabled }, option.value)); }) })) })));
};
export default RadioButtonGroup;
var templateObject_1;
